import FixedFooterWrapper from "./FixedFooterWrapper"

export default FixedFooterWrapper
